import dayjs from 'dayjs'

// 最大値・最小値の計算するための拡張プラグイン
import minMax from 'dayjs/plugin/minMax'
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrBefore  from 'dayjs/plugin/isSameOrBefore';

// 日本時間に変換する
import 'dayjs/locale/ja'

// プラグイン拡張
dayjs.extend(minMax);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrBefore);
dayjs.locale('ja');

export default dayjs